import Icon, { IconTypes } from "shared/ui/icon";
import { concatClassnames } from "shared/utils/concatClassnames";
import SamplesImageBlock from "./SamplesImageBlock";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { isTestEnvironment } from "shared/utils/checkEnvironment";
import {
  developmentProductMapping,
  productionProductMapping,
} from "./productsMapping";

export const SampleSection = ({
  selectedProduct,
  selectedCategoryCode,
}: {
  selectedProduct: CategoryStandardProduct | undefined;
  selectedCategoryCode: string;
}) => {
  // Select product mappings based on environment
  const productMapping = isTestEnvironment()
    ? developmentProductMapping
    : productionProductMapping;

  const match = window.location.pathname.match(/\/producten\/([^/?#]+)/);
  const slug = match ? match[1] : undefined;
  // This function is called when the user clicks on the button, mapping based on environment
  const goToKleurstaalProduct = () => {
    const baseUri = "/producten/kleurstaal-" + slug + "?standard-product=";

    const productID = selectedProduct?.code
      ? productMapping[selectedProduct?.code]
      : "";
    const fullURI = `${baseUri}${productID}&selectedCategory=${selectedCategoryCode}`;
    window.open(fullURI, "_blank");
  };

  return (
    <div className="gg-relative gg-border-b gg-border-t gg-bg-[#F5F4F7] gg-px-5 gg-pb-5 gg-pt-[50px]">
      <SamplesImageBlock className="gg-absolute gg-inset-0 -gg-top-20" />

      <div className="gg-absolute gg-right-[14px] gg-top-4">
        <p className="gg-pt-1.5 gg-text-sm gg-text-dark-blue sm:gg-pt-0">
          Vanaf €3,95 per stuk
        </p>
      </div>
      <div>
        <h3 className="gg-text-lg gg-font-bold gg-leading-6 gg-text-dark-blue">
          Vergelijk onze kleurstalen thuis
        </h3>

        <p className="gg-mt-3 gg-text-sm gg-text-dark-blue">
          Met een kleurstaal kun je beoordelen of dit akoestische paneel bij de
          rest van je interieur past.{" "}
        </p>

        <button
          className={concatClassnames(
            "gg-group gg-relative gg-mt-5 gg-flex gg-items-center gg-rounded-sm gg-text-sm gg-font-bold gg-text-dark-blue gg-underline gg-underline-offset-[5px] gg-transition-all hover:gg-text-dark-blue/60 enabled:gg-cursor-pointer",
          )}
          onClick={goToKleurstaalProduct}
        >
          Bestel jouw kleurstalen
          <Icon
            name={IconTypes.ARROW_RIGHT}
            className={concatClassnames(
              "gg-ml-4 gg-transition gg-duration-500 gg-ease-in-out group-hover:gg-translate-x-1.5",
            )}
          />
        </button>
      </div>
    </div>
  );
};
